export default __webpack_public_path__ + "static/media/news2.332c025b.jpg";